/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many square feet are in a square meter?`)
};

const es_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos pies cuadrados hay en un metro cuadrado?`)
};

const de_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Quadratfuß hat ein Quadratmeter?`)
};

const nl_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel vierkante voet zitten in een vierkante meter?`)
};

const fr_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de pieds carrés y a-t-il dans un mètre carré ?`)
};

const it_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti piedi quadrati ci sono in un metro quadrato?`)
};

const pt_br2_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos pés quadrados tem em um metro quadrado?`)
};

const pt_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos pés quadrados existem num metro quadrado?`)
};

const ja_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1平方メートルには何平方フィートありますか?`)
};

const zh_uc_area_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq1_q", locale)
	if (locale === "en") return en_uc_area_faq1_q(inputs)
	if (locale === "es") return es_uc_area_faq1_q(inputs)
	if (locale === "de") return de_uc_area_faq1_q(inputs)
	if (locale === "nl") return nl_uc_area_faq1_q(inputs)
	if (locale === "fr") return fr_uc_area_faq1_q(inputs)
	if (locale === "it") return it_uc_area_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq1_q(inputs)
	if (locale === "pt") return pt_uc_area_faq1_q(inputs)
	if (locale === "ja") return ja_uc_area_faq1_q(inputs)
	return zh_uc_area_faq1_q(inputs)
};